import { ModelBase } from 'store/model-base';

export class CmsDataDetail extends ModelBase {
    public static storeName: string = 'cmsDataDetail';

    public accountNo: string;
    public dataUsage: CmsDataUsage;
    public dataOptionsPlanDecriptions: CmsDataOptionsPlanDecriptions;
    public dataOptions: string;
    public manageThisUserCta: string;
    public assignUserCta: string;
    public cbmAssignUserCta: string;
    public usageHistoryPageData: CmsUsageHistoryPageData;
    public planSwitchModal: CmsPlanSwitchModal;
    public inUseIcon: CmsMediaImage;
    public miniIcon: CmsMediaImage;
    public dataIcon: CmsMediaImage;
    public tabletIcon: CmsMediaImage;
    public byTheGigIcon: CmsMediaImage;
    public alertIcon: CmsMediaImage;
    public infoIconGrey: CmsMediaImage;
    public dollarIcon: CmsMediaImage;
    public inUse: string;
    public scheduledIcon: CmsMediaImage;
    public scheduled: string;
    public selectedBadge: string;
    public includedBadge: string;
    public activeBadge: string;
    public inUseBadge: string;
    public offBadge: string;
    public pendingRemovalBadge: string;
    public switchPlanLabel: string;
    public cancelSwitchLabel: string;
    public upgradePlanLabel: string;
    public featureTitle: string;
    public lineStatus: CmsLineStatus;
    public pairedDevice: CmsPairedDevice;
    public planPrice: CmsPlanPrice;
    public dataSaverData: CmsDataSaver;
    public planSevenXmCallGuard: CmsPlanSevenXmCallGuard;
    public errorText: string;
    public addons: CmsAddonsLanding;
    public changeSharedDataBtnLabel: string;
    public scheduledSwitchLevel5ManageCta: string;
    public switchToUnlIntroCta: string;
    public switchToUnlPremiumCta: string;
    public switchToTabletUnlIntroCta: string;
    public switchToTabletUnlPremiumCta: string;
    public warningMessage: CmsWarningMessage;
    public planSwitchReview: CmsPlanSwitchReview;
    public levelMoveInfo: LevelMoveInfo;
    public gtpPassPrice: string;
    public mexCanPassPrice: string;
    public manageUnlimitedCta: string;
    public upgradeToUnlPlusCta: string;
    public unlimited: string;
    public unlimitedIntro: string;
    public unlimitedPlus: string;
    public unlimitedPremium: string;
    public tabletUnlimitedIntro: string;
    public tabletUnlimitedPremium: string;
    public manageUnlimitedTabletCta: string;
    public servicePromotions: CmsServicePromotions;
    public segmentFiveTablet: CmsSegmentFiveTablet;
    public segmentFiveCBMTabletUnlIntro: CmsSegmentFiveTablet;
    public segmentFiveCBMTabletUnlPremium: CmsSegmentFiveTablet;
    public segmentFiveCBMPlanIds: string[];
    public cbmNoLevelPlanIds: string[];
    public broadbandLabel: LabelSegmentDetails[];
    public cbmBroadbandLabel: CBMLabelSegmentDetails[];
    public cbmBroadbandLabelContent: CBMLabelDetails;
}
